module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "order-list-item"
  }, [_c('router-link', {
    staticClass: "order-details-link",
    attrs: {
      "to": {
        name: 'order-details',
        params: {
          id: _vm.orderNumber
        }
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "order-date small-6 column"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('order.label.order-date'))), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.orderDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 column"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('status-chips', {
    attrs: {
      "status": _vm.orderStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "delivery-flags float-right"
  }, [(_vm.deliveryDateHasChanged) ? _c('ui-icon', {
    staticClass: "notif-warning-color",
    attrs: {
      "icon": "warning"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deliveryDateIsDifferent) ? _c('ui-icon', {
    staticClass: "notif-info-color",
    attrs: {
      "icon": "info"
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "content lateral-sub-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-5 large-3 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.order-number')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 large-9 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.orderNumber))])])]), _vm._v(" "), (_vm.orderRef) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-5 large-3 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.customer-reference')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 large-9 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.orderRef))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row delivery-date"
  }, [_c('div', {
    staticClass: "small-5 large-3 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 large-9 column",
    class: {
      'notif-warning-color': _vm.deliveryDateHasChanged, 'notif-info-color': _vm.deliveryDateIsDifferent
    }
  }, [_c('div', [_c('strong', [(_vm.deliveryDateFrom && !_vm.deliveryDateTo) ? _c('span', [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date-on', {
    onDate: _vm.formatDate(_vm.deliveryDateFrom)
  })))]) : _vm._e(), _vm._v(" "), (_vm.deliveryDateFrom && _vm.deliveryDateTo) ? _c('span', [_vm._v(_vm._s(_vm.orderDeliveryDate(_vm.deliveryDateFrom, _vm.deliveryDateTo)))]) : _vm._e()])]), _vm._v(" "), (_vm.deliveryDateIsDifferent || _vm.deliveryDateHasChanged) ? _c('div', {
    staticClass: "delivery-messages"
  }, [(_vm.deliveryDateHasChanged) ? _c('div', {
    staticClass: "notif-warning-color"
  }, [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date-has-changed')))]) : _vm._e(), _vm._v(" "), (_vm.deliveryDateIsDifferent) ? _c('div', {
    staticClass: "notif-info-color"
  }, [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date-is-different')))]) : _vm._e()]) : _vm._e()])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb287bf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderListItem.vue
// module id = 308
// module chunks = 2